<ng-container *rxLet="state$ as state">
  <section class="location-details" data-test-id="user-profile-location-container">
    <h4 class="font-bold">Preferred work location(s)</h4>
    @if (!state.preferredWorkLocationsLoading) {
      @if (state.preferredWorkLocations) {
        <p>Specify the locations where you would consider working in case of interesting job opportunities.</p>
        <location-edit
          [canEdit]="state.canEdit"
          [hint]="true"
          [locations]="state.preferredWorkLocations"
          (serverError)="onServerError()"
          (updateSuccess)="preferredWorkLocationsUpdated($event)"
          data-test-id="user-profile-locationEdit-container"
          updateMethodName="updateLocationsProfile"
        ></location-edit>
      } @else {
        <no-data></no-data>
      }
    } @else {
      <div class="flex flex-center-start w-full h-full">
        <loader color="primary"></loader>
      </div>
    }
  </section>
</ng-container>
